<script setup lang="ts">
import { useI18n } from "vue-i18n";

import { svgIcon, baseFile } from "@/common/components";

import { FileType } from "@/common/types/common";

const { t } = useI18n();

const emit = defineEmits(["update-data", "model-download"]);

const props = withDefaults(
  defineProps<{
    model?: boolean;
    extensions?: string[];
    background?: string;
  }>(),
  {
    model: false,
    background: "#eeeeee",
  }
);

function update(data: FileType) {
  emit("update-data", data);
}
</script>

<template>
  <section class="file-upload-form">
    <base-file :extensions="props.extensions" @change="update" />

    <template v-if="model">
      <div class="model-download" @click="emit('model-download')">
        <svg-icon icon="download" size="1.5rem" />
        {{ t("common.texts.model_download") }}
      </div>
    </template>
  </section>
</template>

<style lang="scss" scoped>
.file-upload-form {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1.25rem;

  .model-download {
    cursor: pointer;
    user-select: none;
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    width: fit-content;

    &:hover {
      color: var(--primary);
    }
  }
}
</style>